import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';

const speechToTextCallable = httpsCallable(functions, 'speechToText');

export const speechToText = async ({ audioBase64, encoding, sampleRateHertz, languageCode, alternativeLanguageCodes }) => {
  const payload = { audioBase64, encoding, languageCode };
  if (sampleRateHertz) {
    payload.sampleRateHertz = sampleRateHertz;
  }
  if (alternativeLanguageCodes && alternativeLanguageCodes.length > 0) {
    payload.alternativeLanguageCodes = alternativeLanguageCodes;
  }
  const result = await speechToTextCallable(payload);
  return result.data;
};

